import { Edit, KeyboardArrowDown } from '@mui/icons-material'
import { Box, Collapse, IconButton } from '@mui/material'
import { useState } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import styled from 'styled-components'
import DeliveryDetails from '../../CreateAQuote/DeliveryDetails/DeliveryDetails'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'

const TinyButton = styled(IconButton)<{ fontcolor: string }>`
  &.MuiButtonBase-root.MuiIconButton-root svg {
    width: 14px;
    height: 14px;
    color: ${(props) => props.fontcolor};
  }
`

const AddressRow = styled.div`
  font-size: 14px;
  display: flex;
  margin-top: 2px;

  .label {
    width: 130px;
    font-weight: bold;
  }
`

const ProjectAddress = () => {
  const [expanded, setExpanded] = useState(false)
  const [showEditDeliveryDetails, setShowEditDeliveryDetails] = useState(false)

  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )

  const handleToggle = () => {
    setExpanded(!expanded)
  }

  const handleEdit = () => {
    setShowEditDeliveryDetails(true)
  }

  return (
    <>
      <Box sx={{ display: 'flex', fontSize: 14 }}>
        <strong>Delivery Details</strong>
        <TinyButton
          onClick={handleToggle}
          fontcolor="black"
          style={{ marginRight: 10 }}
        >
          <KeyboardArrowDown
            sx={expanded ? { transform: 'rotate(180deg)' } : null}
          />
        </TinyButton>

        {expanded && (
          <TinyButton onClick={handleEdit} fontcolor="var(--color-gray)">
            <Edit />
          </TinyButton>
        )}
      </Box>

      <Collapse in={expanded} sx={{ pl: 3 }}>
        {project.deliveryDetails && (
          <>
            <AddressRow>
              <div className="label">Shipping address</div>
              <div className="value">
                {project.shippingAddress &&
                  `${project.shippingAddress.streetAddress}${
                    project.shippingAddress.aptSuiteOther &&
                    ` ${project.shippingAddress.aptSuiteOther}`
                  }, ${project.shippingAddress.city}, ${
                    project.shippingAddress.state
                  }`}
              </div>
            </AddressRow>
            <AddressRow>
              <div className="label">Return address</div>
              <div className="value">
                {project.returnAddress &&
                  `${project.returnAddress.streetAddress}${
                    project.returnAddress.aptSuiteOther &&
                    ` ${project.returnAddress.aptSuiteOther}`
                  }, ${project.returnAddress.city}, ${
                    project.returnAddress.state
                  }`}
              </div>
            </AddressRow>
            <AddressRow>
              <div className="label">Carrier</div>
              <div className="value">
                {project.deliveryDetails.carrier &&
                  project.deliveryDetails.carrier}
              </div>
            </AddressRow>
            <AddressRow>
              <div className="label">Account number</div>
              <div className="value">
                {project.deliveryDetails.accountNumber &&
                  project.deliveryDetails.accountNumber}
              </div>
            </AddressRow>
            <AddressRow>
              <div className="label">Shipping method</div>
              <div className="value">
                {project.deliveryDetails.shippingMethod &&
                  project.deliveryDetails.shippingMethod}
              </div>
            </AddressRow>
            <AddressRow>
              <div className="label">Expedited</div>
              <div className="value">
                {project.deliveryDetails.expedited ? 'Yes' : 'No'}
              </div>
            </AddressRow>
            <AddressRow>
              <div className="label">Comments</div>
              <div className="value">
                {project.deliveryDetails.additionalComments &&
                  project.deliveryDetails.additionalComments}
              </div>
            </AddressRow>
          </>
        )}
      </Collapse>

      <ModalPopUp
        title="Edit delivery details"
        setShowModal={setShowEditDeliveryDetails}
        showModal={showEditDeliveryDetails}
        variant="medium"
      >
        <DeliveryDetails
          projectCreateContext={false}
          handleCancel={() => setShowEditDeliveryDetails(false)}
        />
      </ModalPopUp>
    </>
  )
}

export default ProjectAddress
